import StockEditIcon from "@mui/icons-material/Edit";
import LockResetIcon from "@mui/icons-material/LockReset";
import StockSaveIcon from "@mui/icons-material/Save";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import styled, { css } from "styled-components";
import { HXButton } from "./HXButton";
import { HXTextField, withExplicitProps } from "./base.styles";
import { FlexColumn } from "./common.styles";
export const FormItem = styled.div `
    display: flex;
    align-items: center;
    padding: 5px 0px;
    font-size: ${fontSizes.SMALL};
    height: 35px;
`;
export const UnlimitedHeightFormItem = styled(FormItem) `
    height: auto;
    min-height: 35px;
`;
export const FormLabel = withExplicitProps(styled.div, "required", "error") `
    width: 170px;
    font-weight: bold;

    ${(props) => props.required &&
    css `
            &::after {
                content: " *";
                color: ${colors.tulip_main};
            }
        `}

    ${(props) => props.error &&
    css `
            color: ${colors.tulip_main};
        `}
`;
export const Input = styled.div `
    vertical-align: middle;

    & ${HXTextField} {
        width: 300px;
    }
`;
export const ReadonlyText = styled.div ``;
export const SubTitle = styled.div `
    font-size: ${fontSizes.MEDIUM};
`;
export const SubTitleWrapper = styled.div `
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 10px;
`;
export const EditIcon = styled(StockEditIcon) `
    margin-bottom: -2px;
    margin-right: 5px;
`;
export const PasswordResetIcon = styled(LockResetIcon) `
    margin-bottom: -2px;
    margin-right: 5px;
`;
export const ButtonArea = styled.div `
    display: flex;
    gap: 20px;
`;
export const RightAlignedButtonArea = styled.div `
    display: flex;
    gap: 20px;
    justify-content: right;
`;
export const CenterAlignedButtonArea = styled(FlexColumn) `
    gap: 16px;
    align-items: center;
    justify-content: center;
    text-align: left;
`;
export const MultipleInvitationText = styled.div `
    font-size: ${fontSizes.TINY};
    color: ${colors.black_light};
`;
export const SaveButton = styled(HXButton) ``;
export const ResetButton = styled(HXButton).attrs({ secondary: true }) ``;
export const SaveIcon = styled(StockSaveIcon) `
    font-size: ${fontSizes.STANDARD} !important;
`;
export const UserAvatarImage = styled.img `
    object-fit: contain;
    height: 40px;
    vertical-align: middle;
    margin-right: 5px;

    .fallback > & {
        display: none;
    }
`;
export const FallbackName = styled.div `
    display: none;

    font-size: ${fontSizes.MICRO};
    width: 60px;

    .fallback > & {
        display: block;
    }
`;
